import { generateClient } from 'aws-amplify/api';
import PropTypes from 'prop-types';
import { createClientContact } from '../../../graphql/custom_mutations';

const client = generateClient();

export const addClientContact = async (props) => {
  if (props) {
    try {
      console.log('addClientContact props: ', props);

      const response = await client.graphql({
        query: createClientContact,
        variables: { input: props },
      });

      console.log('addClientContact response: ', response);
      const results = response.data.createSpkDJTClientContactTbl.id;
      console.log('addClientContact results: ', results);
      return results;
    } catch (err) {
      return 'error addClientContact: ' + err;
    }
  } else {
    return null;
  }
};

addClientContact.propTypes = {
  props: PropTypes.object.isRequired,
};
